/**
 * PersoFields — campi per lo stage `perso` (motivo + note).
 * ★ Fase 59.P2 — estratto da StageTransitionModal.jsx. Comportamento invariato.
 */
import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { LOST_REASONS } from './constants';
import i18n from '../../i18n';

export function PersoFields({ form, set }) {
  return (
    <div className="space-y-3">
      <div className="rounded-md bg-red-50 border border-red-200 p-3 text-xs text-red-900">
        {i18n.t('stageTransition.lostIntro', 'Il lead è stato perso. Inserisci la motivazione per migliorare il funnel.')}
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide">{i18n.t('stageTransition.reason', 'Motivo')} *</Label>
        <Select value={form.lost_reason} onValueChange={(v) => set('lost_reason', v)}>
          <SelectTrigger data-testid="lost-reason-select" className="mt-1">
            <SelectValue placeholder={i18n.t('stageTransition.selectPh', 'Seleziona…')} />
          </SelectTrigger>
          <SelectContent>
            {LOST_REASONS.map((r) => (
              <SelectItem key={r} value={r}>{r}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide">{i18n.t('stageTransition.detailedNotes', 'Note dettagliate')}</Label>
        <Textarea
          rows={3}
          value={form.lost_note}
          onChange={(e) => set('lost_note', e.target.value)}
          placeholder={i18n.t('stageTransition.lostNotePh', 'Cosa è successo? Cosa avremmo potuto fare diversamente?')}
          data-testid="lost-note-textarea"
          className="mt-1"
        />
      </div>
    </div>
  );
}
